import React, { useRef, useEffect } from 'react';

export default function Animation({
  src,
  className,
  autoPlay = true,
  muted = true,
  loop = false,
  preload = 'auto',
}) {
  const videoRef = useRef(null);

  // Ensure the video always starts at 0 on load
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    if (autoPlay) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch(err => console.warn('Playback prevented:', err));
      }
    }
  }, [src, autoPlay]);

  // Restart playback when the video ends, if not using native looping
  useEffect(() => {
    const video = videoRef.current;
    if (!video || loop) return;

    const handleEnded = () => {
      video.currentTime = 0;
      if (autoPlay) {
        const replayPromise = video.play();
        if (replayPromise && typeof replayPromise.then === 'function') {
          replayPromise.catch(err => console.warn('Replay prevented:', err));
        }
      }
    };

    video.addEventListener('ended', handleEnded);
    return () => {
      video.removeEventListener('ended', handleEnded);
    };
  }, [src, loop, autoPlay]);

  return (
    <video
      ref={videoRef}
      src={src}
      className={className}
      preload={preload}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      playsInline
    />
  );
}